import {
  Button,
  ButtonSize,
  ButtonVariant,
  Show,
  TextArea
} from "shared/components";
import { StickerSquare } from "untitledui-js-base";
import { useState } from "react";
import {
  ActivityItem,
  AddNoteMutation,
  DeleteNoteMutation,
  EditNoteMutation
} from "./types";
import { TimeLine, TimeLineItem } from "shared/components/TimeLine";
import { BulletItem } from "shared/app/ActivityLog/BulletItem";
import { ActivityNote } from "shared/app/ActivityLog/ActivityNote";

export const ActivitiesList = ({
  addNoteMeta,
  editNoteMeta,
  deleteNoteMeta,
  activityLogs
}: {
  addNoteMeta: AddNoteMutation;
  editNoteMeta: EditNoteMutation;
  deleteNoteMeta: DeleteNoteMutation;
  applicationId: string;
  activityLogs: ActivityItem[];
}) => {
  const [newNote, setNewNote] = useState<string>("");

  return (
    <div className="flex flex-col h-full">
      <div className="p-6 border-b">
        <TextArea
          id="note"
          className="!mb-0"
          placeholder="You can write a note here"
          onChange={(e) => setNewNote(e.target.value)}
          value={newNote}
        />
        <Show if={newNote.length > 0}>
          <div className="mt-3 flex justify-end gap-2">
            <Button
              variant={ButtonVariant.BASE}
              size={ButtonSize.SM}
              onClick={() => setNewNote("")}
            >
              Cancel
            </Button>
            <Button
              variant={ButtonVariant.PRIMARY}
              size={ButtonSize.SM}
              onClick={() => {
                addNoteMeta.mutateAsync(newNote).then(() => setNewNote(""));
              }}
              disabled={!newNote}
            >
              Add Note
            </Button>
          </div>
        </Show>
      </div>

      <div className="h-full">
        {!activityLogs.length ? (
          <div className="mt-8 flex flex-auto flex-col items-center justify-center">
            <div className="mb-6 flex h-[64px] w-[64px] items-center justify-center rounded-full bg-alpha-40 p-5">
              <StickerSquare size="24" className="stroke-content-500" />
            </div>
            <p className="text-sm font-medium text-content-300">No logs yet</p>
          </div>
        ) : (
          <div className="px-6 h-full w-full flex-1 overflow-x-hidden overflow-y-auto hide-scroll bg-background-900">
            <TimeLine wrapperClassName="ml-4 border-alpha-100 pt-1 w-full">
              {activityLogs.map((activity) => {
                return (
                  <TimeLineItem
                    bullet={
                      <BulletItem
                        activityItem={activity}
                        decisionStatus={
                          typeof activity.details === "object"
                            ? activity.details.status
                            : ""
                        }
                      />
                    }
                    wrapperClassName="mt-8 h-full"
                    key={
                      activity.updated_at +
                      activity.activity_type +
                      activity.created_at
                    }
                    childrenClassName="w-full"
                  >
                    <ActivityNote
                      editNoteMeta={editNoteMeta}
                      deleteNoteMeta={deleteNoteMeta}
                      activityItem={activity}
                    />
                  </TimeLineItem>
                );
              })}
            </TimeLine>
          </div>
        )}
      </div>
    </div>
  );
};
